export default "__VITE_ASSET__BGzg3aKS__"